$('.recently-content-sections').hide();
Shopify.Products.showRecentlyViewed({
    howManyToShow: 8,
    wrapperId: 'recently-viewed-products-grid',
    templateId: 'recently-viewed-product-grid-template',
    onComplete: function() {
        var recentlyViewBlock = $('.recently-viewed-products');
        var recentlyGrid = recentlyViewBlock.find('.products-grid');
        var productGrid = recentlyGrid.children();
        var rows = recentlyGrid.data('rows');
        var rowlt = recentlyGrid.data('rowlt');

        if(productGrid.length) {
            recentlyViewBlock.show();
        $('.recently-content-sections').show();

            if(recentlyViewBlock.is(':visible')) {

                if(!recentlyGrid.hasClass('slick-initialized')) {
                  _theme.initSlickSlider(recentlyGrid, {
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 5,
                    slidesToScroll:5,
                    arrows:true,
                    responsive: [
                      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, dots: false, infinite: true }},
                      { breakpoint: 600, settings: { dots: false, slidesToShow: 2.3, slidesToScroll: 1}},
                      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1}}
                    ]
                  });
                  // recentlyGrid.slick({});
                };

                if($('.spr-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                };

                if (window.show_multiple_currencies) {
                  Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), '#dropdown-cart span.money', 'money_format');
                };
            };
        }

        else {
            recentlyViewBlock.hide();
        };

        _theme.initSmartWishlist();
        handleWishlistChange && handleWishlistChange();

        var wishListItems = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];

        if (!wishListItems.length) {
            return;
        }

        for (var i = 0; i < wishListItems.length; i++) {
            var icon = $('[data-product-handle="'+ wishListItems[i] +'"]');
            icon.addClass('whislist-added');
            icon.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
        };
    }
});
Shopify.Products.recordRecentlyViewed();